import { get, getPaginated, getWithPagination, patch, post, remove } from '@/api/base'

const zonesApi = {
  get: async (areaUuid, zoneUuid) => {
    const response = await get({
      path: `areas/${areaUuid}/zones/${zoneUuid}`,
    })
    return response.success ? response.data.zone : null
  },
  getAllForCompany: async companyUuid => {
    const response = await getPaginated({
      path: `companies/${companyUuid}/zones`,
      valuePath: 'zones',
    })
    return response.success ? response.values : []
  },
  getAllInSite: async (siteUuid, params) => {
    const { values, success } = await getPaginated({
      path: `sites/${siteUuid}/zones`,
      valuePath: 'zones',
      params,
    })

    if (success) {
      return values
    }
  },
  selectableZones: async (siteUuid, params) => {
    const { success, values } = await getPaginated({
      path: `sites/${siteUuid}/selectable_zones`,
      valuePath: 'zones',
      params,
    })

    return success ? values : []
  },
  getAllInArea: async areaUuid => {
    const response = await getWithPagination({
      path: `areas/${areaUuid}/zones`,
      valuePath: 'zones',
    })
    return response
  },
  getInArea: async (areaUuid, params) => {
    const response = await get({
      path: `areas/${areaUuid}/zones`,
      params,
    })
    return response.success
      ? {
          zones: response.data.zones,
          pagination: response.data.meta.pagination,
        }
      : null
  },
  update: async (areaUuid, zoneUuid, params) => {
    const response = await patch({
      path: `areas/${areaUuid}/zones/${zoneUuid}`,
      params,
    })
    return response.success ? response.data.zone : null
  },
  delete: async (areaUuid, zoneUuid) => {
    return await remove({
      path: `areas/${areaUuid}/zones/${zoneUuid}`,
    })
  },
  create: async (areaUuid, params) => {
    const response = await post({
      path: `areas/${areaUuid}/zones`,
      params,
    })
    return response.success ? response.data.zone : null
  },
}

export default zonesApi
